import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "../../utils/theme";

const PortfolioAllocationChart = ({ data }) => {
  const { theme } = useTheme();
  /**
   * Expected data format:
   * [
   *  { label: "Equity", value: 25000000 },
   *  { label: "ETFs", value: 24998976 },
   *  ...
   * ]
   */

  const labels = data.map((item) => item.label);
  const series = data.map((item) => Number(item.value) || 0);

  const total = series.reduce((a, b) => a + b, 0);

  const options = {
    chart: {
      type: "donut",
    },
    labels,
    legend: {
      show: false, // we will create custom legend
    },
    theme: {
      mode: theme,
    },
    stroke: {
      width: 2,
      colors: [theme === "dark" ? "#1f2937" : "#fff"],
    },
    colors: [
      "#ffc107cc",
      "#198754cc",
      "#0dcaf0cc",
      "#dc3545cc",
      "#6c757dcc",
      "#edc949",
      "#af7aa1",
      "#ff9da7",
      "#9c755f",
      "#bab0ab",
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: {
            show: true,
            name: {
              color: theme === "dark" ? "#f8fafc" : "#111827",
            },
            value: {
              color: theme === "dark" ? "#f8fafc" : "#111827",
            },
            total: {
              show: true,
              color: theme === "dark" ? "#f8fafc" : "#111827",
              formatter: () => "Total",
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => {
          const percentage = total ? ((value / total) * 100).toFixed(1) : 0;
          return `₹${value.toLocaleString()} (${percentage}%)`;
        },
      },
    },
  };

  return (
    <div className="d-flex justify-content-center gap-4 align-items-center">
      {/* Chart */}
      <div style={{ width: 140 }}>
        <Chart options={options} series={series} type="donut" height={140} />
      </div>

      {/* Custom Legend */}
      <div className="pie-legend mt-2">
        <ul className="list-unstyled">
          {labels.map((label, i) => {
            const value = series[i];
            const percentage = total ? ((value / total) * 100).toFixed(1) : 0;

            return (
              <li key={i} className={theme === "dark" ? "text-light" : "text-dark"}>
                <span
                  className="me-2"
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: options.colors[i],
                    display: "inline-block",
                    borderRadius: 3,
                  }}
                ></span>
                <small>
                  <small>
                    {label} ({percentage}%)
                  </small>
                </small>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PortfolioAllocationChart;
